export default __webpack_public_path__ + "static/product-feature-archiving-abf654c25efd20f8f59b9f7eff2a222c.svg";